import Backdrop from "../Modal/Backdrop";

const Loading: React.FC<{ loadingText: string; hideBackdrop?: boolean }> = (
  props
) => (
  <>
    <span className={`${props.hideBackdrop ? "invisible" :"visible"}`}>
      <Backdrop />
    </span>
    <div className="flex flex-col absolute inset-0 flex items-center justify-center space-x-2 z-100">
      <div className="flex items-center justify-center space-x-2">
        <div
          className="w-4 h-4 bg-primaryColor-normal rounded-full animate-bounce"
          style={{ animationDelay: "0.2s" }}
        ></div>
        <div
          className="w-4 h-4 bg-primaryColor-normal rounded-full animate-bounce"
          style={{ animationDelay: "0.4s" }}
        ></div>
        <div
          className="w-4 h-4 bg-primaryColor-normal rounded-full animate-bounce"
          style={{ animationDelay: "0.6s" }}
        ></div>
      </div>
      <p className="font-bold text-xl mt-5 text-white">{props.loadingText}</p>
    </div>
  </>
);

export default Loading;
